import React from 'react'
import { Typography } from 'antd'

export const ContentfulRenderHeading = (level, node) => {
  const { Title } = Typography
  return <Title level={level}>{node.content[0].value}</Title>
}
